import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { TitlesForVerificationList } from "./TitlesForVerificationList";
import { TitleDetailPage } from "./TitleDetailPage";
import { RouteGuard } from "../../guards/RouteGuard";
import { TitleEdit } from "./TitleEdit";
function TitlesForVerification() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitlesForVerificationList, { type: "MONOGRAPH" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitleDetailPage, { type: "MONOGRAPH" }))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, null,
                React.createElement(TitleEdit, { type: "MONOGRAPH" }))); } })));
}
export default TitlesForVerification;
